import React, { useEffect, useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { Input, Button, Pagination, Tabs, Drawer, Select, Radio, Slider, message, Spin, Modal } from 'antd'
import { AppstoreOutlined } from '@ant-design/icons'
import $api from 'sdss/api'
import { ArticleListData, ArticleListMethod } from 'sdss/types/ListArticlesModules'
import ArticleCard from 'sdss/components/ArticleCard'
import KnowledgeGraph from 'sdss/components/KnowledgeGraph'
import styles from './styles.module.scss'
import BasicLayout from 'sdss/layouts/BasicLayout'

const { Search } = Input
const { TabPane } = Tabs
const { Option } = Select

interface ListArticleProps {
  queryWord: string;
}

export default function SearchView(props: ListArticleProps) {
  const [drawerVisible, setDrawerVisible] = useState(false)
  const [defaultArticleListData, setDefaultArticleListData] = useState<ArticleListMethod[]>([])
  const page = useRef(1)
  const [minPublicationDatetimeStamp, setMinPublicationDatetimeStamp] = useState('不限')
  const [years, setYears] = useState('不限')
  const [activeKey, setActiveKey] = useState('1')
  const [total, setTotal] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const { queryWord } = props
  const [visible, setVisible] = useState(false)
  const [inputValue, setInputValue] = useState(queryWord)
  const [articleTypeList, setArticleTypeList]: any = useState([])
  let history = useHistory()


  const defaultGraphData: ArticleListData = {
    article_count: 1,
    article_list: [],
    corrected_word: '',
    treenumber_list: [],
  }
  const graphData = useRef<ArticleListData>(defaultGraphData) // 用于从异步回调中读取最新的graphData


  useEffect(() => {
    getSearch(queryWord)
  }, [queryWord])
  function getSearch(queryWord: string) {
    if (escape(queryWord).indexOf('%u') >= 0) {
      message.error('暂不支持中文搜索')
      return
    }

    let params = { page: 1, page_size: 10, query_word: queryWord }
    setIsLoading(true)
    $api.search(params)
      .then((res: any) => {
        if (res.message === 'ok') {
          setDefaultArticleListData(res.data.article_list)
          graphData.current = res.data
          graphData.current.corrected_word = queryWord
          setTotal(res.data.article_count)
          setIsLoading(false)
          page.current = 1
        } else {
          if (res.message) {
            message.error(res.message)
          } else {
            message.error('服务器错误')
          }
          setIsLoading(false)
        }
      })
  }

  function onClose() {
    setVisible(false)
  }

  /** 搜索列表 */
  const searchContent = (pageNumber: number, useSearch: string, article_type_list?: string[], min_publication_datetime_stamp?: string) => {
    if (escape(useSearch).indexOf('%u') >= 0) {
      message.error('暂不支持中文搜索')
      return
    }
    setActiveKey('1')
    setIsLoading(true)
    if (useSearch !== '') {
      let listRequest: any = {
        page: pageNumber,
        page_size: 10,
        query_word: useSearch,
      }
      let antInput = document.getElementsByClassName('ant-input ant-input-lg')[0]
      antInput.setAttribute('value', listRequest.query_word)
      if (articleTypeList.length > 0) {
        listRequest.article_type_list = articleTypeList
      }
      if (minPublicationDatetimeStamp !== '不限') {
        listRequest.min_publication_datetime_stamp = Number(minPublicationDatetimeStamp)
      }
      $api.listArticles(listRequest).then((res: any) => {
        const { data } = res
        if (res.message === 'ok') {
          handelPage(1)
          setDefaultArticleListData(data?.article_list)
          graphData.current = data
          setTotal(data?.article_count)
          setIsLoading(false)
          if (res.data.corrected_word === '') {
            message.error(res.message)
          } else {
            return (
              <Modal
                title={res.message}
                visible={visible}
                onCancel={onClose}
                destroyOnClose={true}
                maskClosable={false}
              />
            )
          }
          setIsLoading(false)
        } else {
          message.error(res.message)
          setIsLoading(false)
        }
      })
    } else {
      message.error('请输入搜索词')
      setIsLoading(false)
    }
  }


  /** 点击搜索  */
  const doSearch = (value: string) => {
    setActiveKey('1')
    if (value) {
      history.replace(`/search/${value}`)
    }
    setInputValue(value)
  }

  /** 分页 */
  const handelPage = (num: number) => {
    page.current = num
    getSearch(inputValue)
  }

  // const searchList = () => {
  //   let useSearch = ''
  //   setDefaultArticleListData([])
  //   searchContent(1, decodeURIComponent(useSearch))
  // }


  const sliderMarks = {
    0: '0',
    10: '10+'
  }
  const sliderTipFormatter = (val?: number) => {
    if (val === 10) {
      return <span>10+</span>
    } else {
      return <span>{val}</span>
    }
  }

  const suffix = (
    <AppstoreOutlined
      style={{
        fontSize: 16,
        color: drawerVisible ? '#1890ff' : '#d9d9d9',
      }}
      onClick={() => {
        setActiveKey('1')
        setDrawerVisible(true)
      }}
    />
  )

  const selectArticleTypeList = (value: string[]) => {
    setArticleTypeList(value)
  }

  const selectDate = (e: any) => {
    setYears(e.target.value)
    let timeStamp = new Date().setFullYear((new Date().getFullYear() - Number(e.target.value))).toString()
    setMinPublicationDatetimeStamp(timeStamp)
  }

  const eliminate = () => {
    setYears('不限')
    setArticleTypeList([])
    setMinPublicationDatetimeStamp('不限')
  }

  return (
    <div data-flex="dir:top cross:center" className="wrapper">
      <BasicLayout />
      <div className={styles.content}>
        <div style={{ marginBottom: 24 }}>
          <Search
            placeholder="请输入搜索词"
            enterButton="搜索"
            size="large"
            suffix={suffix}
            onSearch={doSearch}
            defaultValue={inputValue}
          />
        </div>

        <div style={{ color: '#999' }}>共 <span style={{ fontWeight: 500, color: '#333' }}>{total}</span> 篇MEDLINE文章</div>
        <Tabs defaultActiveKey="1" activeKey={activeKey} onChange={(activeKey) => {
          if (graphData.current.treenumber_list.length) {
            setActiveKey(activeKey)
          }
        }}>
          <TabPane tab="文献列表" key="1">
            <Spin spinning={isLoading} size="large" style={{ width: '100%' }}>
              {defaultArticleListData.map((item) => ArticleCard(item))}
            </Spin>

            <div data-flex="main:center" style={{ margin: '40px 0' }}>
              <Pagination
                current={page.current}
                onChange={handelPage}
                defaultCurrent={page.current}
                total={total}
                pageSize={10}
                showSizeChanger={false}
                showTitle={false}
              />
            </div>
          </TabPane>
          <TabPane tab="知识图谱" key="2">
            <div style={{ marginBottom: 50, border: '1px solid #d9d9d9' }}>
              <KnowledgeGraph graphData={graphData.current} />
            </div>
          </TabPane>
        </Tabs>


        <Drawer
          className={styles.drawer}
          placement="right"
          visible={drawerVisible}
          onClose={() => setDrawerVisible(false)}
        >
          <div className={styles.text}>文献类型</div>
          <Select
            style={{ width: '100%' }}
            mode="multiple"
            placeholder="请选择类型"
            onChange={selectArticleTypeList}
            value={articleTypeList}
          >
            <Option value="Books and Documents">书和文件</Option>
            <Option value="Clinical Trial">临床研究</Option>
            <Option value="Meta-Analysis">Meta分析</Option>
            <Option value="Randomized Controlled">随机对照试验</Option>
            <Option value="Review">综述</Option>
            <Option value="Systematic Review">系统综述</Option>

          </Select>
          <div className={styles.text}>出版日期</div>
          <Radio.Group
            defaultValue="不限"
            buttonStyle="outline"
            size="small"
            style={{ width: '100%' }}
            onChange={selectDate}
            value={years}

          >
            <Radio.Button autoFocus={true} value="不限" style={{ width: '25%' }}>不限</Radio.Button>
            <Radio.Button autoFocus={true} value="3" style={{ width: '25%' }}>3年</Radio.Button>
            <Radio.Button autoFocus={true} value="5" style={{ width: '25%' }}>5年</Radio.Button>
            <Radio.Button autoFocus={true} value="10" style={{ width: '25%' }}>10年</Radio.Button>
          </Radio.Group>
          <div className={styles.text}>影响因子</div>
          <Slider
            range
            max={10}
            min={0}
            marks={sliderMarks}
            tipFormatter={sliderTipFormatter}
            defaultValue={[1, 3]}
          />
          <div className={styles.buttonGroup}>
            <Button style={{ marginRight: 5 }} onClick={() => { eliminate() }}>清除</Button>
            <Button type="primary" onClick={() => { searchContent(1, inputValue) }}>搜索</Button>
          </div>
        </Drawer>
      </div>
    </div>
  )
}